import { render, staticRenderFns } from "./EmailMessageHeader.vue?vue&type=template&id=5c2dbcf6&scoped=true&"
import script from "./EmailMessageHeader.vue?vue&type=script&lang=js&"
export * from "./EmailMessageHeader.vue?vue&type=script&lang=js&"
import style0 from "./EmailMessageHeader.vue?vue&type=style&index=0&id=5c2dbcf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2dbcf6",
  null
  
)

export default component.exports